import React, { useEffect, useRef, useState } from "react";
import { useParams } from "react-router-dom";
import { getImagenWhatsApp } from "../../constants/whatsapp";

function ViewImgWhatsapp() {
    const { imagen } = useParams();

    const [urlImagen, setUrlImagen] = useState("");
    const [urlLink, setUrlLink] = useState("");
    const [zoomAbierto, setZoomAbierto] = useState(false);
    const [escala, setEscala] = useState(1);
    const [posicion, setPosicion] = useState({ x: 0, y: 0 });
    const punteros = useRef(new Map());
    const gesto = useRef(null);

    const cerrarZoom = () => {
        setZoomAbierto(false);
        setEscala(1);
        setPosicion({ x: 0, y: 0 });
        punteros.current.clear();
        gesto.current = null;
    };

    const distanciaEntre = ([a, b]) => Math.hypot(a.x - b.x, a.y - b.y);

    const iniciarGesto = (event) => {
        event.currentTarget.setPointerCapture(event.pointerId);
        punteros.current.set(event.pointerId, { x: event.clientX, y: event.clientY });
        const puntos = [...punteros.current.values()];

        if (puntos.length === 2) {
            gesto.current = {
                tipo: "pinza",
                distancia: distanciaEntre(puntos),
                escala,
            };
        } else {
            gesto.current = {
                tipo: "arrastre",
                punto: puntos[0],
                posicion,
            };
        }
    };

    const moverGesto = (event) => {
        if (!punteros.current.has(event.pointerId)) return;
        punteros.current.set(event.pointerId, { x: event.clientX, y: event.clientY });
        const puntos = [...punteros.current.values()];

        if (puntos.length === 2) {
            if (gesto.current?.tipo !== "pinza") {
                gesto.current = { tipo: "pinza", distancia: distanciaEntre(puntos), escala };
            }
            const nuevaEscala = Math.min(6, Math.max(1, gesto.current.escala * (distanciaEntre(puntos) / gesto.current.distancia)));
            setEscala(nuevaEscala);
        } else if (puntos.length === 1 && gesto.current?.tipo === "arrastre" && escala > 1) {
            setPosicion({
                x: gesto.current.posicion.x + puntos[0].x - gesto.current.punto.x,
                y: gesto.current.posicion.y + puntos[0].y - gesto.current.punto.y,
            });
        }
    };

    const terminarGesto = (event) => {
        punteros.current.delete(event.pointerId);
        const puntos = [...punteros.current.values()];
        gesto.current = puntos.length === 1
            ? { tipo: "arrastre", punto: puntos[0], posicion }
            : null;
    };

    useEffect(() => {
        const cargarImagen = async () => {
            try {
                const data = await getImagenWhatsApp(imagen);
                // console.log(data);

                if (data.status) {
                    setUrlImagen(data.url);
                    setUrlLink(data.url_link);
                }
            } catch (error) {
                console.error(error);
            }
        };

        cargarImagen();
    }, [imagen]);

    return (
        <div
            style={{
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
                alignItems: "center",
                minHeight: "100vh",
                gap: "12px",
                padding: "16px",
                boxSizing: "border-box",
            }}
        >
            {urlImagen && (
                <>
                    <img
                        src={urlImagen}
                        alt={imagen}
                        onClick={() => setZoomAbierto(true)}
                        style={{
                            maxWidth: "100%",
                            maxHeight: "85vh",
                            cursor: "zoom-in",
                        }}
                    />
                    {urlLink && (
                        <a href={urlLink} style={{ color: "#0d6efd" }}>
                            Mas Información
                        </a>
                    )}
                </>
            )}
            {zoomAbierto && (
                <div
                    role="dialog"
                    aria-modal="true"
                    aria-label="Imagen ampliada"
                    onPointerDown={iniciarGesto}
                    onPointerMove={moverGesto}
                    onPointerUp={terminarGesto}
                    onPointerCancel={terminarGesto}
                    style={{
                        position: "fixed",
                        inset: 0,
                        zIndex: 1000,
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        overflow: "hidden",
                        background: "rgba(0, 0, 0, 0.9)",
                        touchAction: "none",
                    }}
                >
                    <img
                        src={urlImagen}
                        alt={imagen}
                        draggable="false"
                        style={{
                            maxWidth: "100%",
                            maxHeight: "100%",
                            userSelect: "none",
                            transform: `translate(${posicion.x}px, ${posicion.y}px) scale(${escala})`,
                            transition: punteros.current.size ? "none" : "transform 150ms ease-out",
                        }}
                    />
                    <button
                        type="button"
                        onClick={cerrarZoom}
                        aria-label="Cerrar imagen ampliada"
                        style={{
                            position: "absolute",
                            top: "16px",
                            right: "16px",
                            width: "44px",
                            height: "44px",
                            border: 0,
                            borderRadius: "50%",
                            background: "rgba(255, 255, 255, 0.9)",
                            color: "#111",
                            fontSize: "28px",
                            lineHeight: 1,
                        }}
                    >
                        ×
                    </button>
                </div>
            )}
        </div>
    );
}

export default ViewImgWhatsapp;
